import { MouseEvent, MutableRefObject } from "react";

/**
 *
 * @param targetInfo MouseEvent or location hash (e.g. #tripbuilder)
 * @param navRef
 */
export const scrollToSection = (
    targetInfo: MouseEvent<HTMLAnchorElement> | string,
    navRef: MutableRefObject<HTMLElement | null> | null | undefined,
) => {
    if (typeof targetInfo !== "string") {
        targetInfo.preventDefault();
    }
    const hash =
        typeof targetInfo === "string"
            ? targetInfo
            : targetInfo.currentTarget.hash;
    const targetId = hash.slice(1);
    const element = document.getElementById(targetId);
    const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion)",
    ).matches;
    const navHeight = navRef?.current?.getBoundingClientRect().height || 0;
    if (element) {
        const rect = element.getBoundingClientRect();
        window.scrollTo({
            top: rect.top + window.scrollY - navHeight,
            behavior: prefersReducedMotion ? "instant" : "smooth",
        });
        element.focus({ preventScroll: true });
    }
};
